// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"f579dbea","87":"c3f2e72f","119":"b70eb862","243":"806d7f10","440":"62a0d4f1","462":"db60a0b1","498":"859fad61","658":"ec11a7b5"}[chunkId] + ".chunk.js";
};